import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiCalendar, FiUser /* FiActivity */ } from 'react-icons/fi';
import { RiLeafLine } from 'react-icons/ri';
import { BsChatSquareDots } from 'react-icons/bs';

import { ROUTES } from 'utils/constants';
import { useOptionalEvieAppContext } from 'components/evieApp/EvieAppProvider';

import './bottom-nav.scss';

const BottomNav = () => {
  const { t } = useTranslation();
  const {
    location: { pathname },
  } = useHistory();
  // /download renders this nav outside EvieAppProvider, so this state can legitimately be absent.
  const { isPremium = false, loading = false } = useOptionalEvieAppContext();
  // While loading, the tier is still unknown, so showing the tab now means retracting it a moment later.
  const displayProgramLink = !loading && !isPremium && pathname !== ROUTES.EVIE_DOWNLOAD;

  const handleDisplayRoute = (currentPath, path) => currentPath === path;

  return (
    <nav className="bottom-nav">
      <NavLink to={ROUTES.EVIE_HOME} className="bottom-nav__link" activeClassName="selected">
        <FiCalendar className="bottom-nav__icon" />
        {handleDisplayRoute(pathname, ROUTES.EVIE_HOME) ? <span>{t('evieApp.bottomNav.home')}</span> : null}
      </NavLink>
      {displayProgramLink && (
        <NavLink to={ROUTES.EVIE_MY_PROGRAM} className="bottom-nav__link" activeClassName="selected">
          <RiLeafLine className="bottom-nav__icon" />
          {handleDisplayRoute(pathname, ROUTES.EVIE_MY_PROGRAM) ? <span>{t('evieApp.bottomNav.program')}</span> : null}
        </NavLink>
      )}
      {/* <NavLink to={ROUTES.EVIE_ACTIVITY} className="bottom-nav__link" activeClassName="selected">
        <FiActivity className="bottom-nav__icon" />
        {handleDisplayRoute(pathname, ROUTES.EVIE_ACTIVITY) ? <span>{t('evieApp.bottomNav.activity')}</span> : null}
      </NavLink> */}
      <NavLink to={ROUTES.EVIE_ASSISTANT} className="bottom-nav__link" activeClassName="selected">
        <BsChatSquareDots className="bottom-nav__icon" />
        {handleDisplayRoute(pathname, ROUTES.EVIE_ASSISTANT) ? <span>{t('evieApp.bottomNav.assistant')}</span> : null}
      </NavLink>
      <NavLink to={ROUTES.EVIE_PROFILE} className="bottom-nav__link" activeClassName="selected">
        <FiUser className="bottom-nav__icon" />
        {handleDisplayRoute(pathname, ROUTES.EVIE_PROFILE) ? <span>{t('evieApp.bottomNav.profile')}</span> : null}
      </NavLink>
    </nav>
  );
};

export default BottomNav;
